'use client';
// External libs
import React from 'react';
import { useDropzone } from 'react-dropzone';
import clsx from 'clsx';
// Lib
import { DropZone, DropZoneLabel, DropZoneIcon, ErrorText } from './file-drop-zone.styles';

import { FileDropZoneProps } from './file-drop-zone.interfaces';

/**
 * Creates a drag and drop zone
 * @param props the component props
 */
const FileDropZone = (props: FileDropZoneProps): JSX.Element => {
  const { onDrop, accept } = props;
  const { getRootProps, getInputProps, isDragActive, fileRejections } = useDropzone({
    onDrop,
    accept,
    maxSize: 50000000, //bytes
  });
  const dropZoneProps = getRootProps();
  const inputProps = getInputProps();

  /**
   * Instructions when drag is active
   */
  const dragActiveInstructions = <DropZoneLabel>Relachez pour déposer</DropZoneLabel>;

  /**
   * Default instructions template
   */
  const defaultInstructions = (
    <div>
      <DropZoneIcon color="tertiary" name="add" size="extra-large" />
      <DropZoneLabel>Cliquez ou déposez un fichier</DropZoneLabel>
    </div>
  );

  return (
    <div className={clsx(props.className)}>
      <DropZone className={clsx(isDragActive && 'active')} {...dropZoneProps}>
        <input {...inputProps} />
        <div>{(isDragActive && dragActiveInstructions) || defaultInstructions}</div>
      </DropZone>
      {(fileRejections && fileRejections.length && (
        <ErrorText variant="body2" color="primary">
          Un problème est survenu avec votre fichier. Il se peut qu&apos;il soit trop volumineux.
        </ErrorText>
      )) ||
        null}
    </div>
  );
};

export default FileDropZone;
